import type { ComponentProps } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { Upload } from '@/components/common/upload';

import { FormField } from '../form-field';

type UploadBaseProps = Omit<ComponentProps<typeof Upload>, 'value' | 'onChange'>;

export type UploadFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = UploadBaseProps & {
  name: TName;
  control: Control<TFieldValues>;
  label?: string;
  help?: string;
  required?: boolean;
};

export function UploadField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ name, control, label, help, required, ...rest }: UploadFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} label={label} help={help} required={required}>
      {({ field, fieldState }) => (
        <Upload
          {...rest}
          id={name}
          status={fieldState.error ? 'error' : undefined}
          // Upload seeds its list from value once at mount; use a key prop to remount on reset.
          value={field.value ?? []}
          onChange={field.onChange}
        />
      )}
    </FormField>
  );
}
